import { render, staticRenderFns } from "./generalization.vue?vue&type=template&id=0a872727&scoped=true"
import script from "./generalization.vue?vue&type=script&lang=js"
export * from "./generalization.vue?vue&type=script&lang=js"
import style0 from "./generalization.vue?vue&type=style&index=0&id=0a872727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a872727",
  null
  
)

export default component.exports